import { useInfiniteQuery } from "@tanstack/react-query";
import { GeneralResponse, ICity, Token } from "../../../types/api";
import { ICitiesRequest, ICitiesResponse } from "../../../types/apis/general";
import { LongStaleTime, Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";

export const useInfiniteCities = (
  payload: ICitiesRequest | null,
  token: Token,
  enabled: boolean,
) => {
  const fetchCities = async (
    payload: ICitiesRequest,
    token: Token,
  ): Promise<GeneralResponse> => {
    const filteredPayload: Record<string, string | number | boolean> = {};

    if (payload.Start !== undefined && payload.Start !== null) {
      filteredPayload.Start = payload.Start;
    }
    if (payload.Count !== undefined && payload.Count !== null) {
      filteredPayload.Count = payload.Count;
    }

    if (payload.Name !== undefined && payload.Name !== null) {
      filteredPayload.Name = encodeURIComponent(payload.Name);
    }

    const queryString = Object.keys(filteredPayload)
      .map((key) => `${key}=${filteredPayload[key]}`)
      .join("&");

    return await Api<any, GeneralResponse<ICitiesResponse[]>>({
      method: Methods.GET,
      endpoint: `${EndPoints.cities}?CountryId=${payload.CountryId}&${queryString}`,
      token,
    });
  };

  const Count = payload?.Count ?? 10;

  return useInfiniteQuery<GeneralResponse<ICity[]>, Error>({
    queryKey: ["infinite-cities", { ...payload, Count }],
    queryFn: ({ pageParam = 0 }: any) =>
      fetchCities(
        {
          ...payload,
          Start: pageParam,
          Count,
          Name: payload?.Name,
          CountryId: payload?.CountryId ?? null,
        },
        token,
      ),
    enabled,
    initialPageParam: 0,
    staleTime: LongStaleTime,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.Data.length === 0) {
        return undefined;
      }
      return pages.length * Count;
    },
  });
};
